import React from 'react'
import Paper from '@mui/material/Paper';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';



const columns = [
    { id: 'Address', label: 'Address' },
    { id: 'CTag', label: 'CTag'},
];

const SheetTableLeft = ({ 
    page, 
    rowsPerPage, 
    selectedRowRight,
    sheetMappingData, 
    handleChangePage, 
    handleChangeRowsPerPage, 
    handleSelectRowRight
}) => {

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <TableContainer className='TableVirtuoso' sx={{ maxHeight: "100vh" }}>
                <Table className='connectionTable' stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sheetMappingData?.data?.length > 0 ? sheetMappingData?.data.map((row,i) => {
                            return (
                                <TableRow 
                                    role="checkbox" 
                                    tabIndex={-1} 
                                    key={i}
                                    onClick={() => handleSelectRowRight(i + 1, row)}
                                    className={selectedRowRight === i + 1 ? 'activeRow' : ''}
                                >
                                    {columns.map((column) => {
                                        const value = row[column.id];
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {column?.format && typeof value === 'number'
                                                    ? column.format(value) 
                                                    : column.id === 'actions' ? 
                                                    <>  
                                                        <IconButton 
                                                            color="inherit" 
                                                            title="Edit Sheet Data"
                                                           // onClick={()=> handleEditRow(row)}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </>
                                                    : value 
                                                }
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        }) : <TableRow><TableCell colSpan={3}>No Data Available. </TableCell></TableRow>}
                    </TableBody>
                </Table>
            </TableContainer>
            {sheetMappingData?.total > 0 ?
                <TablePagination
                    rowsPerPageOptions={[100, 200, 500,{label:'ALL',value: -1}]}
                    component="div"
                    count={sheetMappingData?.total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} 
                />
                : <></>
            }
        </Paper> 
    )
}

export default SheetTableLeft